import { useState, useEffect } from 'react';
import { getLocalString } from 'pf-core/utilities';
import styles from './styles.module.css';
import downloadIcon from './../../assets/img/download-logo.svg';
import tickIcon from './../../assets/img/tick-icon.svg';
import { usePresignedUrl } from './usePresignedUrl';
import {
  DOWNLOAD_TITLE_TEXT,
  DOWNLOAD_SUBTITLE_TEXT,
  VALIDATED_SUBTITLE_TEXT,
  VALIDATED_TITLE_TEXT,
  PASSCODE_REGEX
} from './constants';
import { HeaderBox } from './components/HeaderBox';
import { Form } from './components/Form';
import { DownloadBox } from './components/DownloadBox';

export const PreSignedFileDownload = () => {
  const [passcode, setPasscode] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const { submitPasscode, error, isLoading, presignedUrl, filename } =
    usePresignedUrl();

  const fileSize = '';
  const params = new URLSearchParams(window.location.search);
  const docId = params.get('docId');

  const validatedTitleText = getLocalString(
    VALIDATED_TITLE_TEXT,
    VALIDATED_TITLE_TEXT
  );
  const validatedSubtitleText = getLocalString(
    VALIDATED_SUBTITLE_TEXT,
    VALIDATED_SUBTITLE_TEXT
  );
  const downloadTitleText = getLocalString(
    DOWNLOAD_TITLE_TEXT,
    DOWNLOAD_TITLE_TEXT
  );
  const downloadSubtitleText = getLocalString(
    DOWNLOAD_SUBTITLE_TEXT,
    DOWNLOAD_SUBTITLE_TEXT
  );

  useEffect(() => {
    setIsValid(false);
  }, []);

  const handleDownload = () => {
    window.open(presignedUrl, '_blank');
  };

  const handleChange = (e) => {
    setPasscode(e.target.value);
    const valid = PASSCODE_REGEX.test(e.target.value);
    setIsValid(valid);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid) {
      submitPasscode(docId, passcode);
    }
  };

  const handleTogglePasswordVisibility = () => {
    setPasswordVisible((prevVisibility) => !prevVisibility);
  };

  return (
    <div className={styles.container}>
      {presignedUrl ? (
        <>
          <HeaderBox
            icon={tickIcon}
            title={validatedTitleText}
            subtitle={validatedSubtitleText}
          />
          <DownloadBox
            filename={filename}
            fileSize={fileSize}
            handleDownload={handleDownload}
          />
        </>
      ) : (
        <>
          <HeaderBox
            icon={downloadIcon}
            title={downloadTitleText}
            subtitle={downloadSubtitleText}
          />
          <Form
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            isValid={isValid}
            submitPasscode={submitPasscode}
            isLoading={isLoading}
            error={error}
            isPasswordVisible={isPasswordVisible}
            handleTogglePasswordVisibility={handleTogglePasswordVisibility}
          />
        </>
      )}
    </div>
  );
};
